import { Button, CircularProgress, Grid } from "@mui/material";
import { getUserClaims } from "features/application/application-slice";
import { fetch_system_settings, save_system_settings } from "features/auto-thunks";
import { get_all_systemSetting, is_systemSetting_busy } from "features/systemSetting/systemSetting-slice";
import { CoherentScreen, SystemSetting } from "models";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TitleService from "title-service";

export default function CoherentScreenControls(props: { coherentScreen: CoherentScreen }) {
    const { coherentScreen } = props;
    const all_system_settings = useSelector(get_all_systemSetting);
    const system_settings_busy = useSelector(is_systemSetting_busy);
    let dispatch = useDispatch();
    let claims = useSelector(getUserClaims);
    useEffect(() => {
        dispatch(fetch_system_settings({
            playerId: claims?.player
        }))
    }, [claims?.player]);
    if (system_settings_busy) {
        return (
            <>
                <CircularProgress />
            </>
        )
    }
    if (!coherentScreen)
        return (
            <>

            </>
        )
    if (!all_system_settings.length) {
        return (
            <>
                No system settings
            </>
        )
    }
    let default_screen = all_system_settings.find(x => x.name === 'default_screen');
    if (!default_screen) {
        return (
            <>
                <Grid item>
                    <Button variant="contained" onClick={async () => {
                        dispatch(save_system_settings({
                            playerId: claims?.player,
                            setting: {
                                name: 'default_screen',
                                value: coherentScreen.id
                            } as SystemSetting
                        }))
                    }}>
                        {TitleService('Set as default screen')}
                    </Button>
                </Grid>
            </>
        )
    }


    if (default_screen?.value !== coherentScreen?.id) {
        return (
            <>
                <Grid item>
                    <Button variant="contained" onClick={async () => {
                        dispatch(save_system_settings({
                            playerId: claims?.player,
                            setting: {
                                ...default_screen,
                                name: 'default_screen',
                                value: coherentScreen.id
                            } as SystemSetting
                        }))
                    }}>
                        {TitleService('Set as default screen')}
                    </Button>
                </Grid>
            </>
        )
    }

    return (
        <>
            <Grid item>
                <Button variant="contained" disabled={true}>
                    {TitleService('Is default screen')}
                </Button>
            </Grid>
        </>
    )
}